import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';


class WindowPortal extends React.PureComponent {
  constructor(props) {
    super(props);
    // STEP 1: create a container <div>
    this.containerEl = document.createElement('div');
    this.externalWindow = null;
  }

  componentDidMount() {
    // STEP 3: open a new browser window and store a reference to it
    // NOTE: setting the title in the 'open' call does not seem to work. Always
    // get 'undefined' as the title. Set the title after the window is opened
    const windowOpts = `width=${this.props.width},height=${this.props.height},left=0,top=0`;
    this.externalWindow = window.open('', '', windowOpts);
    this.externalWindow.document.title = this.props.title;
    // STEP 4: append the container <div> (that has props.children appended to
    // it) to the body of the new window
    this.externalWindow.document.body.appendChild(this.containerEl);

    // update the state in the parent component if the user closes the
    // new window
    this.externalWindow.addEventListener('beforeunload', () => {
      this.props.closeWindowPortal();
    });
  }

  componentWillUnmount() {
    // STEP 5: This will fire when this.state.showWindowPortal in the parent
    // component becomes false So we tidy up by closing the window
    this.externalWindow.close();
  }

  render() {
    // STEP 2: append props.children to the container <div> that isn't mounted
    // anywhere yet
    return ReactDOM.createPortal(this.props.children, this.containerEl);
  }
}


WindowPortal.propTypes = exact({
  closeWindowPortal: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
});

export default WindowPortal;
